<form *ngIf="formGroup && group && labelMap && formGroup.get(group.id)" [formGroup]="formGroup">
  <h4>
    <digires-state-indicator
      [readOnly]="readOnly"
      [readOnlyReason]="readOnlyReason"
    ></digires-state-indicator>
    {{group.selector.label}}
    <mat-icon class="tooltip-icon" svgIcon="tooltip" matTooltip="{{group.selector.tooltip}}"></mat-icon>
  </h4>
  <mat-radio-group [formControlName]="group.id">
    <mat-radio-button *ngFor="let opt of group.selector.options" [value]="opt.id">
      {{opt.label}}
      <ul>
        <li *ngIf="opt.commonMsDefIds.length === 0 && opt.tooltip">{{opt.tooltip}}</li>
        <li *ngFor="let msDefId of opt.commonMsDefIds">
          {{refMap[msDefId]}} - {{labelMap[msDefId]}}
          <mat-icon class="tooltip-icon" svgIcon="tooltip" matTooltip="{{tooltipMap[msDefId]}}"></mat-icon>
        </li>
      </ul>
    </mat-radio-button>
  </mat-radio-group>
</form>
